import React, { useEffect, useState } from "react";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { Card, CardBody, CardHeader } from "../../../../_metronic/_partials/controls";
import { Col, Row } from "react-bootstrap";
import { Button, Checkbox, createTheme, FormControlLabel, MuiThemeProvider, TextField } from "@material-ui/core";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { useHistory, useParams } from "react-router-dom";
// import { deleteTherapist, getTherapistById, postTherapist, updateTherapist } from "../../../../api/therapist";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { deleteUser, getUserById, postUser, sendVerifyUserMailAndRefresh, updateUser } from "../../../../api/user";
import { grantPermissionsCalendar } from "../../../../api/calendar";

// Create theme for delete button (red)
const theme = createTheme({
  palette: {
    secondary: {
      main: '#F64E60'
    }
  }
})

function getEmptyTherapist() {
    return {
        active: true,
        isTherapist: true,
        isAdmin: false,
    }
}

export default function EditTherapistPage() {
    const therapistId = useParams().id
    const history = useHistory();
    const [therapist, setTherapist] = useState(getEmptyTherapist());
    const [openConfirmDialog, setOpenConfirmDialog] = useState(0);
    const [refresh, setRefresh] = useState(null);
    
    const { isLoading: isLoadingData, disableLoading: disableLoadingData, ContentSkeleton } = useSkeleton()
    
    useEffect(() => {
        setRefresh(false);
    }, [refresh])
    
    useEffect(() => {
        fetch();
    }, [])

    function fetch() {
        if (!therapistId) { disableLoadingData(); return;}
        getUserById(therapistId)
            .then((res) => {
                const therapist = res.data;
                setTherapist(therapist);
                disableLoadingData();
            })
            .catch((error) => {
                alertError({

                    error,
                    customMessage: "No se ha podido encontrar el terapeuta."
                })
            })
    }

    function saveTherapist() {
        if (!therapist?._id) {
            postUser(therapist)
                .then((res) => {
                    alertSuccess({ title: "Éxito!", customMessage: "Terapeuta creado correctamente."});
                    setTherapist({ ...therapist, _id: res?.data?.id, verificationToken: res?.data?.token});
                    setOpenConfirmDialog(4);
                    // history.push("/therapists");
                })
                .catch((error) => {
                    alertError({ error, customMessage: "No se ha podido crear el therapist"});
                })
            }
            else {
                updateUser(therapist._id, therapist)
                .then((res) => {
                    alertSuccess({ title: "Éxito!", customMessage: "Terapeuta actualizado correctamente."});
                    history.push("/therapists");
                })
                .catch((error) => {
                    alertError({ error, customMessage: "Could not update therapist"});
                })
        }
    }

    const handleChange = (element) => (event) => {
        setTherapist({ ...therapist, [element]: event.target.value });
    }

    function permissionsCalendar() {
        grantPermissionsCalendar(therapist?._id, therapist?.fullName, therapist?.surname, therapist?.email)
            .then((res) => {
                alertSuccess({ message: "Mail de Calendar enviado correctamente!" });
            })
            .catch((error) => {
                alertError({ error, message: "No se ha podido enviar el mail."});
            })
    }

    function verificationEmail() {
        sendVerifyUserMailAndRefresh(therapist?.verificationToken)
            .then((res) => {
                alertSuccess({ title: "Éxito!", customMessage: "Mail de verificación enviado correctamente." });
            })
            .catch((error) => {
                alertError({ error, customMessage: "No se ha podido enviar el mail." });
            })
    }

    if (isLoadingData) 
        return (<ContentSkeleton />)
    return (
        <>
            <Card>
                <CardHeader title="Edit therapist" />
                <CardBody>
                    <Row>
                        <Col>
                            <TextField
                                label="Name"
                                value={therapist?.fullName}
                                onChange={handleChange("fullName")}
                                margin="normal"
                                variant="outlined"
                                required
                            />
                        </Col>
                        <Col>
                            <TextField
                                label="Surname"
                                value={therapist?.surname}
                                onChange={handleChange("surname")}
                                margin="normal"
                                variant="outlined"
                                required
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <TextField
                                label="Email"
                                value={therapist?.email}
                                onChange={handleChange("email")}
                                margin="normal"
                                variant="outlined"
                                required
                            />
                        </Col>
                        <Col>
                            <TextField
                                label="Phone"
                                value={therapist?.phone}
                                onChange={handleChange("phone")}
                                margin="normal"
                                variant="outlined"
                                required
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormControlLabel
                                control={<Checkbox checked={therapist?.active} onChange={() => setTherapist({ ...therapist, active: !therapist?.active })} name="checkActive" />}
                                label="Active"
                            />
                        </Col>
                    </Row>
                </CardBody>
            </Card>
            <Button
                onClick={() => history.push('/therapists')}
                variant="outlined"
                style={{ marginRight: '20px' }}>
                Atrás
            </Button>
            <Button
                onClick={() => saveTherapist()}
                variant="outlined"
                color="primary"
                style={{ marginRight: '20px' }}>
                Save therapist
            </Button>
            {therapist?._id && <>
                <MuiThemeProvider theme={theme}>
                <Button
                    onClick={() => setOpenConfirmDialog(1)}
                    variant="outlined"
                    color="secondary"
                    style={{ marginRight: '20px' }}>
                    Delete therapist
                </Button>
                </MuiThemeProvider>

                <ConfirmDialog
                title={'Seguro que quieres eliminar el terapeuta?'}
                open={openConfirmDialog === 1}
                setOpen={setOpenConfirmDialog}
                onConfirm={() => {
                    deleteUser(therapist._id)
                        .then((res) => {
                            alertSuccess({ title: "Éxito!", customMessage: "Terapeuta eliminado correctamente." });
                            history.push("/therapists");
                        })
                        .catch((error) => {
                            alertError({ error, customMessage: "No se ha podido eliminar el terapeuta." });
                        })
                }}
                />

                { !therapist?.password && (
                    <Button
                        onClick={() => setOpenConfirmDialog(2)}
                        variant="outlined"
                        style={{ marginRight: '20px' }}>
                        Enviar mail de confirmación
                    </Button>
                )}

                <ConfirmDialog
                title={'Seguro que quieres enviar un mail de verificación al terapeuta?'}
                open={openConfirmDialog === 2}
                setOpen={setOpenConfirmDialog}
                onConfirm={() => {
                    verificationEmail();
                }}
                />

            { !therapist?.calendarId && (
                <Button
                    onClick={() => setOpenConfirmDialog(3)}
                    variant="outlined"
                    style={{ marginRight: '20px' }}>
                    Enviar permisos google calendar
                </Button>
            )}

            <ConfirmDialog
                title={'Seguro que quieres enviar el email con la garantización de los permisos para el Calendar compartido al terapueta?'}
                open={openConfirmDialog === 3}
                setOpen={setOpenConfirmDialog}
                onConfirm={() => {
                    permissionsCalendar();
                }}
            />

            <ConfirmDialog
                title={'Quieres enviar el email de verificación de usuario en conjunto con el de la garantización de permisos para el Calendar compartido al nuevo terapeuta?'}
                open={openConfirmDialog === 4}
                setOpen={setOpenConfirmDialog}
                onConfirm={() => {
                    permissionsCalendar();
                    verificationEmail();
                }}
            />
            </>}
        </>
    )
}